<!-- eslint-disable vue/no-v-html -->
<template>
    <ol
        v-if="currentName"
        v-show="breadcrumbItems.length > 1"
        class="magazine-breadcrumbs"
        itemscope
        itemtype="https://schema.org/BreadcrumbList"
    >
        <li
            v-for="(item, index) in breadcrumbItems"
            :key="index"
            class="magazine-breadcrumbs__item"
            itemscope
            itemtype="https://schema.org/ListItem"
            itemprop="itemListElement"
        >
            <template v-if="!item.isCurrent">
                <LocalizedLink :to="item.target" itemprop="item">
                    <div itemprop="name" class="magazine-breadcrumbs__text" v-html="item.label" />
                </LocalizedLink>
                <svg-icon class="magazine-breadcrumbs__divider" name="keyboard_arrow_right" />
            </template>

            <div
                v-else
                itemprop="name"
                class="magazine-breadcrumbs__text magazine-breadcrumbs__text--current"
                v-html="item.label"
            />
            <meta itemprop="position" :content="index + 1" />
        </li>
    </ol>
</template>

<script>
export default {
    props: {
        currentName: {
            type: String,
            default: null,
        },
        parent: {
            type: Object,
            default: null,
        },
    },
    computed: {
        breadcrumbItems() {
            const { currentName, parent } = this;

            const items = [
                {
                    label: this.$t('common.home'),
                    target: { name: 'magazine' },
                },
            ];

            if (parent && currentName) {
                items.push({
                    label: parent.title,
                    target: { name: 'magazine-category-slug', params: { slug: parent.slug } },
                });
            }

            if (currentName) {
                items.push({
                    isCurrent: true,
                    label: currentName,
                });
            }

            return items;
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.magazine-breadcrumbs {
    display: flex;
    align-items: center;
    @include font-size(12px);
    line-height: 1.2em;

    &__item {
        display: flex;
        align-items: center;

        a {
            color: $primary-text-color;
            text-decoration: none;
        }
    }

    &__text {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:not(.magazine-breadcrumbs__text--current):hover {
            text-decoration: underline;
        }
    }

    &__divider {
        width: 24px;
        height: 24px;
        color: $primary;
    }
}
</style>
